import { Component } from '@angular/core';
import { NavController, NavParams, MenuController } from 'ionic-angular';
import { PlayPage } from '../play/play';
import { HomePage } from '../home/home';
import { Storage } from '@ionic/storage';
import { ReadstoryPage } from '../readstory/readstory';
import { VersusPage } from '../versus/versus'; 

// ---- COMMON MODULES ---- //
import { Functions } from '../../providers/functions';
import { TranslateService } from '@ngx-translate/core';
import { UserdataModel } from '../../providers/userdata-model';
import { GameModel } from '../../providers/game-model';

@Component({
  selector: 'page-endgame',
  templateUrl: 'endgame.html',
  host: { '(window:resize)': 'handleResizeEvents($event)'}
})
export class EndgamePage {
  mood:string;
  scorePartial:number;
  scoreFinalBonuses:number;
  difficulty:number;
  language:number;
  typeOfwin="";
  chunkFinished:boolean;
  downEntropy:number;
  upEntropy:number;
  scoreFinalAI:number;
  entropyFinalAI: number;
  wasGameModeVersus: boolean;

  constructor(public functions: Functions, public playModel: GameModel, public rubedoSideMenu: MenuController, public userdataModel:UserdataModel, public translate: TranslateService, public navCtrl: NavController, public navParams: NavParams, private storage: Storage) {
    this.rubedoSideMenu = rubedoSideMenu;
    this.rubedoSideMenu.enable(false, 'rubedoSideMenu');
    this.functions.setSideMenuColorEnabled(false);
      
    this.scorePartial=0;
    this.mood="superhappy";
  }
  
  goToPlay(){
    if (this.playModel.isGameModeVersusLastGamePlayed()) {
      this.functions.gamemodeVersusActive=true;
    }
    this.stopPlayMusicWhenLeaving("PlayPage");   
    this.navCtrl.popTo(PlayPage);  
  }

  goToMainMenu(){
    //this.navCtrl.popToRoot();
    //this.navCtrl.push(HomePage, {});
    this.navCtrl.setRoot(HomePage, {});
    this.stopPlayMusicWhenLeaving("HomePage");   
  }

  goToReadStory(){
    this.navCtrl.push(ReadstoryPage, {});
    this.stopPlayMusicWhenLeaving("ReadstoryPage");   
  }

  goToGamemodePage(){
    this.navCtrl.push(VersusPage, {});
    this.stopPlayMusicWhenLeaving("VersusPage");    
  }
  
  stopPlayMusicWhenLeaving(pageToGo){
    if(this.chunkFinished){
      this.functions.stopBgMusic('game_youWin');
    }else{
      this.functions.stopBgMusic('game_youLost');
    }
    if (pageToGo=="HomePage" || pageToGo=="VersusPage" || pageToGo=="ReadstoryPage") {
      this.functions.startBgMusic('app_BgMusic');
    }
  }

  /* --------- LIFECYCLE --------- */
  ionViewWillEnter(){
    //before the page in question becomes active
    document.getElementById('sideMenuButton').style.display='none';
    this.functions.changeShowSidemenuButtonTo(true);
    this.scorePartial = this.navParams.get('scorePartial'); 
    this.scoreFinalBonuses = this.navParams.get('scoreFinalBonuses'); 
    this.typeOfwin = this.navParams.get('typeOfwin'); 
    this.chunkFinished = this.navParams.get('chunkFinished'); 
    this.downEntropy = this.navParams.get('downEntropy'); 
    this.upEntropy = this.navParams.get('upEntropy'); 
    this.scoreFinalAI = this.navParams.get('scoreFinalAI'); 
    this.wasGameModeVersus = this.navParams.get('wasGameModeVersus'); 
    this.entropyFinalAI = this.navParams.get('entropyFinalAI'); 
    
    if(!this.wasGameModeVersus){
      if (this.chunkFinished) {
        this.mood="superhappy";
        this.functions.startBgMusic('game_youWin');
      }else{
        this.mood="supersad";
        this.functions.startBgMusic('game_youLost');
      }
    }else{
      if (this.typeOfwin=="win_versus") {
        this.mood="superhappy";
        this.functions.startBgMusic('game_youWin');
      }else{
        this.mood="supersad";
        this.functions.startBgMusic('game_youLost');
      }
    }
    this.functions.getDifficulty();
    this.functions.getLanguage();
  }

  ionViewDidEnter(){
    this.functions.setScaleForBigScreen();
  }

  handleResizeEvents(event: KeyboardEvent) {
    this.functions.setScaleForBigScreen();
  }

  ionViewWillLeave(){
    document.getElementById('sideMenuButton').style.display='block';
  }
  
  /* --------- END IFECYCLE --------- */

}



// WEBPACK FOOTER //
// ./src/pages/endgame/endgame.ts